export const renderCarouselItem = (content, params)=>typeof content === 'function' ? content(params) : content;
